const indexItems = [
  { id: 1, title: '日剧全集', count: '1,286部', icon: 'ri-sun-line', desc: '经典与最新日剧一网打尽' },
  { id: 2, title: '韩剧全集', count: '1,853部', icon: 'ri-star-line', desc: '热门韩剧同步更新中' },
  { id: 3, title: '爱情剧场', count: '642部', icon: 'ri-heart-line', desc: '甜蜜浪漫日韩爱情剧' },
  { id: 4, title: '悬疑推理', count: '387部', icon: 'ri-search-eye-line', desc: '烧脑反转高分悬疑剧' },
  { id: 5, title: '古装历史', count: '215部', icon: 'ri-ancient-gate-line', desc: '日韩古装历史巨制' },
  { id: 6, title: '喜剧搞笑', count: '298部', icon: 'ri-emotion-happy-line', desc: '轻松解压喜剧合集' },
  { id: 7, title: '医疗职场', count: '156部', icon: 'ri-stethoscope-line', desc: '职场与医疗题材精选' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            剧集索引
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            按类型快速浏览日韩影视资源，找到你想看的每一部好剧
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 max-w-4xl mx-auto">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#media"
              className="group flex flex-col items-center gap-3 p-5 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-300/50 hover:bg-primary-50/30 transition-all duration-200 cursor-pointer text-center"
            >
              <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-white transition-colors duration-200">
                <i className={`${item.icon} text-lg`}></i>
              </span>
              <div>
                <h3 className="text-sm font-semibold font-heading text-foreground-950 whitespace-nowrap">
                  {item.title}
                </h3>
                <span className="text-xs text-foreground-500 whitespace-nowrap">{item.count}</span>
                <p className="mt-1 text-xs text-foreground-500 hidden sm:block">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}